import { Outlet } from 'react-router-dom'

const Inbox = () => <Outlet />

export default Inbox
